export function isMaxLengthRuleBroken(object: any, field: string): boolean {
  return Array.from((object as any).errors).some((e: any) => e.field === field && e.rule === 'max');
}
